import styled from 'styled-components';

// Switch compacto: mesma identidade dos booleanos do item (azul #2196F3 ligado,
// cinza #696969 desligado), em escala que cabe numa linha de dica.
export const ZeroCostRow = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 6px 0 2px;
`;

export const ZeroCostSwitch = styled.label`
  display: inline-block;
  position: relative;
  flex: none;
  width: 34px;
  height: 18px;
`;

export const ZeroCostInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #2196f3;
    border-color: #2196f3;
  }

  &:checked + span::before {
    transform: translateX(16px);
    background-color: #fff;
  }

  &:focus-visible + span {
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.4);
  }

  &:disabled + span {
    opacity: 0.55;
    cursor: default;
  }
`;

export const ZeroCostSlider = styled.span`
  position: absolute;
  inset: 0;
  cursor: pointer;
  background-color: #ccc;
  border: 1px solid #696969;
  border-radius: 18px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &::before {
    content: '';
    position: absolute;
    height: 12px;
    width: 12px;
    left: 2px;
    top: 2px;
    background-color: #696969;
    border-radius: 50%;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
  }
`;

export const ZeroCostLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #696969;
  cursor: pointer;
  line-height: 1.3;
`;

// Substitui o bloco de Custo/Markup/Preço quando o serviço sai zerado.
export const ZeroCostNotice = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #3f6b4a;
  background: #e1ebe2;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 12px;
`;
